import React from 'react';
import { formatNumberWithSuffixAsString } from '../../../utils/helpers';
import Flag from '../../../components/Flag/Flag';
import s from './FlowmapPopup.module.scss';

const FlowmapPopup = ({ properties }) => {
    const {
        originalValue,
        startCountry,
        endCountry,
        dataType,
        dataSource,
        unit,
        hsCode,
        hsProductName,
        year,
        description,
    } = properties;

    const formatValue = (value, unit) => {
        if (unit === 'USD') {
            return `$${formatNumberWithSuffixAsString(value, 0)}`;
        }
        return `${formatNumberWithSuffixAsString(value, 0)} ${unit || ''}`.trim();
    };

    const capitalize = (str) => {
        if (str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
        return '';
    };

    return (
        <div className={s.FlowmapPopup}>
            <div className={s.Header}>
                <div className={s.Route}>
                    <Flag countryCode={startCountry} width="1.2rem" />{' '}
                    {startCountry}
                    <span className={s.Arrow}> → </span>
                    <Flag countryCode={endCountry} width="1.2rem" />{' '}
                    {endCountry}
                </div>
                <div className={s.Value}>
                    {formatValue(originalValue, unit)}
                </div>
            </div>
            <div className={s.Details}>
                {description && (
                    <div className={`${s.DetailItem} ${s.Description}`}>
                        {description}
                    </div>
                )}
                {/* {year && (
                    <div className={s.DetailItem}>
                        <span className={s.Label}>Year:</span>
                        <span className={s.Value}>{year}</span>
                    </div>
                )} */}
                {dataType && (
                    <div className={s.DetailItem}>
                        <span className={s.Label}>Category:</span>
                        <span className={s.Value}>{capitalize(dataType)}</span>
                    </div>
                )}
                {/* {dataSource && (
                    <div className={s.DetailItem}>
                        <span className={s.Label}>Source:</span>
                        <span className={s.Value}>{dataSource}</span>
                    </div>
                )} */}
                {hsProductName && (
                    <div className={s.DetailItem}>
                        <span className={s.Label}>Product:</span>
                        <span className={s.Value}>{hsProductName}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FlowmapPopup;
